import { computeFocusTarget, focusElementById } from '@Hooks/useDeleteFocusManager';

const SIDE_PANEL_FOCUS_TARGET = 'querybuilder-tabs';
const DRAG_BUTTON_ID_PREFIX = 'querybuilder-dragfield-';

function getDragButtonId(node) {
  return node?.id ? `${DRAG_BUTTON_ID_PREFIX}${node.id}` : null;
}

function focusDragButtonByUuid(targetUuid) {
  if (!targetUuid) {
    return false;
  }

  const targetContainer = document.querySelector(`[data-uuid="${targetUuid}"]`);
  const targetButton = targetContainer?.querySelector('[data-e2e="drag-button"]');

  if (!targetButton || typeof targetButton.focus !== 'function') {
    return false;
  }

  targetButton.focus();
  return document.activeElement === targetButton;
}

function focusSidePanelTabs() {
  const sidePanel = document.getElementById(SIDE_PANEL_FOCUS_TARGET);
  const firstFocusable = sidePanel?.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
  firstFocusable?.focus();
}

function scheduleFocus(targetId, targetUuid) {
  const focusByTarget = () => {
    if (focusDragButtonByUuid(targetUuid)) {
      return;
    }

    if (targetId && targetId !== SIDE_PANEL_FOCUS_TARGET) {
      focusElementById(targetId);
      if (document.activeElement?.id === targetId) {
        return;
      }
    }

    focusSidePanelTabs();
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(focusByTarget);
  });
}

export function focusDragButtonOrSidePanel(targetNode) {
  const targetUuid = targetNode?.uuid;
  const targetId = targetUuid ? null : getDragButtonId(targetNode) || SIDE_PANEL_FOCUS_TARGET;
  scheduleFocus(targetId, targetUuid);
}

export function focusNextDragButtonOrSidePanel(nodesList, deletingUuid) {
  const list = Array.isArray(nodesList) ? nodesList : [];
  const itemUuids = list.map((node) => node?.uuid).filter(Boolean);

  // Keep focus in node list whenever possible; only fallback to side panel when no nodes remain.
  let targetUuid = null;
  if (itemUuids.length > 0) {
    if (deletingUuid) {
      const computedTarget = computeFocusTarget(itemUuids, deletingUuid, SIDE_PANEL_FOCUS_TARGET);
      targetUuid = computedTarget === SIDE_PANEL_FOCUS_TARGET ? itemUuids[0] : computedTarget;
    } else {
      targetUuid = itemUuids[0];
    }
  }

  const targetId = targetUuid ? null : SIDE_PANEL_FOCUS_TARGET;
  scheduleFocus(targetId, targetUuid);
}
